export default {
  from: 'De',
  to: 'À',
  enterNameOrNumber: 'Saisir le numéro ou le nom',
  typeMessage: 'Saisie du message...',
  send: 'Envoyer',
};
